import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegVisualizacaoService } from '../../../../services/smartinteg-visualizacao.service';
import { ProcessoVisualizacaoResponse } from '../../../../types/smartinteg';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-processo-detalhe-monitor',
  templateUrl: './processo-detalhe-monitor.component.html'
})
export class ProcessoDetalheMonitorComponent implements OnInit {
  processoId!: string;
  processo$?: Observable<ProcessoVisualizacaoResponse | undefined>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private visualizacaoService: SmartintegVisualizacaoService
  ) {}

  ngOnInit(): void {
    this.processoId = this.route.snapshot.paramMap.get('id')!;
    this.carregarProcesso();
  }

  carregarProcesso(): void {
    this.processo$ = this.visualizacaoService.listarProcessosVisualizacao()
      .pipe(
        map(processos => processos.find(p => p.id === this.processoId))
      );
  }

  navegarParaRegistros(tipo: string): void {
    this.router.navigate(['/smartinteg/monitor/processos', this.processoId, tipo]);
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/monitor/processos']);
  }
}
